import { NoRowsOverlayPropsOverrides } from '@mui/x-data-grid-pro';

interface CustomNoRowsOverlayProps
  extends React.HTMLAttributes<HTMLDivElement>, NoRowsOverlayPropsOverrides {
  dataFetchError: boolean;
  noDataDisplay?: JSX.Element | string;
}

const CustomNoRowsOverlay = ({
  dataFetchError,
  noDataDisplay,
}: CustomNoRowsOverlayProps) => (
  <div
    style={{
      alignItems: 'center',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
    }}
  >
    {dataFetchError
      ? 'Error fetching data. Please try again.'
      : noDataDisplay || 'No data found.'}
  </div>
);

export default CustomNoRowsOverlay;
